export default __webpack_public_path__ + "static/media/rodrigo_carbajal.ebd62bbe.jpg";